import { Alert, Button, Card, Center, Group, Stack, Text, Title } from '@mantine/core';
import { useKvkkAydinlatma, useKvkkOnayla } from '../api/queries';
import { QueryStatus } from './parts';
import { ANLAM } from '../theme';

/**
 * KVKK aydınlatma onay ekranı (F1.5·S11 — Kapsam §18; metin YER TUTUCU,
 * madde 33). Temsilcinin İLK girişinde kabuğun YERİNE çıkar: onaysız portala
 * geçilemez — karar sunucudadır (guard KVKK kapısı), bu ekran yalnız akışı
 * taşır; onay sürüm numarasıyla gönderilir, sunucu bayat sürümü 422'ler.
 */
export function KvkkConsentScreen({ onLogout }: { onLogout: () => void }): React.JSX.Element {
  const aydinlatma = useKvkkAydinlatma();
  const onay = useKvkkOnayla();

  return (
    <Center mih="100vh" p="md">
      <Card withBorder maw={640} w="100%" padding="lg">
        <Stack>
          <Title order={3}>KVKK Aydınlatma Metni</Title>
          <QueryStatus queries={[aydinlatma]} />
          {aydinlatma.data && (
            <>
              <Text
                size="sm"
                style={{ whiteSpace: 'pre-wrap' }}
                data-testid="kvkk-metin"
                data-surum={aydinlatma.data.surum}
              >
                {aydinlatma.data.metin}
              </Text>
              {onay.isError && (
                <Alert color={ANLAM.engel} role="alert">
                  {onay.error.message}
                </Alert>
              )}
              <Group justify="space-between">
                <Button variant="subtle" onClick={onLogout}>
                  Çıkış yap
                </Button>
                <Button
                  data-testid="kvkk-onayla"
                  loading={onay.isPending}
                  onClick={() => onay.mutate({ surum: aydinlatma.data.surum })}
                >
                  Okudum, onaylıyorum
                </Button>
              </Group>
            </>
          )}
        </Stack>
      </Card>
    </Center>
  );
}
